import { createFileRoute } from '@tanstack/react-router';
import { MarginReport } from '../../../features/reports/screens/MarginReport';

/** Owned by G25. Report #11 — margin per dispatch/invoice. */
export const Route = createFileRoute('/_authenticated/reports/margin')({
  component: MarginReport,
});
